/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAward} from '@fortawesome/pro-duotone-svg-icons';

const MicrocredentialIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faAward} {...props} />
);

export default MicrocredentialIcon;
